/**
 * @generated SignedSource<<0e6f7cc680efdb3303222fad4e50d1d9>>
 * @relayHash 620017d3eb428f241f754ece571af703
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3286a71f42d694c4f901110034634d94c3baa72003370b2d358c78b96a294aa1

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FormsQuery } from './FormsQuery.graphql';

const node: PreloadableConcreteRequest<FormsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "3286a71f42d694c4f901110034634d94c3baa72003370b2d358c78b96a294aa1",
    "metadata": {},
    "name": "FormsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
